import firebase from 'firebase/app'
import 'firebase/storage'
import guidv1 from 'uuid/v1'

export const storage = firebase.storage()

export default {
  /**
   * 
   * @param {string} dashId - dashboard id
   * @param {any} payload - array of files or a file
   * @param {function} cb - callback function
   */
  async upload (dashId, payload, cb) {
    async function applyUpload (ref, file) {
      await new Promise((resolve) => {
        ref.put(file).then(function () {
          resolve()
        })
      })
    }

    const uploadedFiles = {}

    if (payload instanceof Array) {
      for (let file of payload) {
        const guid = guidv1()
        const ref = storage.ref(`${dashId}/${guid}_${file.name}`)
        await applyUpload(ref, file)
        uploadedFiles[guid] = file.name
      }
    } else {
      const guid = guidv1()
      const ref = storage.ref(`${dashId}/${guidv1(guid)}_${payload.name}`)
      await applyUpload(ref, payload)
      uploadedFiles[guid] = file.name
    }

    if (cb) cb(uploadedFiles)
  },
  /**
   * Get file download url
   * @param {string} dashId - dashboard id
   * @param {string} fileName - file name`
   */
  async getFileUrl (dashId, fileName, cb) {
    storage.ref(`${dashId}/${fileName}`)
      .getDownloadURL()
      .then((url) => {
        cb(null, url)
      })
      .catch((err) => {
        cb(err)
      })
  },
  /**
   * Delete file from storage
   * @param {string} dashId - dashboard id
   * @param {string} fileName - file name
   * @param {function} cb - callback function
   */
  delete (dashId, fileName, cb) {
    const ref = storage.ref(`${dashId}/${fileName}`)

    ref.delete().then(() => {
      cb()
    }).catch((err) => {
      cb(err)
    })
  }
}
